export default class ProductImagesGallery{

    constructor(){
        this.init();
    }

    /**
     * Enabled video
     */
    enableVideo(thumbVideo){
        const
            videoId = thumbVideo.dataset.videoid,
            videoElm = document.getElementById('video-zoom-src-' + videoId),
            galleryElm = document.getElementById('gallery-block');

        // Attach class
        videoElm.classList.add('video_active');
        galleryElm.classList.add('video');
    }

    /**
     * Disabled video
     */
    disableVideo(){
        const active = document.querySelector('.video_active');
        if(active){
            const galleryElm = document.getElementById('gallery-block');
            active.classList.remove('video_active');
            galleryElm.classList.remove('video');
            this.stopVideo(active);
        }
    }

    /**
     * Stop video
     */
    stopVideo(element){
        const iframe = element.querySelector('iframe');
        const video = element.querySelector('video');
        if (iframe !== null) {
            let iframeSrc = iframe.src;
            iframe.src = iframeSrc;
        }
        if(video !== null ) video.pause();
    };

    /**
     * Thumbails Gallery Zoom
     */
    galleryZoom() {
        let self = this;
        $("#proimage").elevateZoom({
            zoomType: "inner",
            cursor: 'crosshair',
            gallery: 'thumbs_list',
            galleryActiveClass: 'active',
            imageCrossfade: true,
            scrollZoom: true,
            onImageSwapComplete: function (e) {
                self.thumbActive();
            }
        });
    }

     /**
     * Gallery Thumb Active
     */
    thumbActive(){
        $('.owl-item').removeClass('active');
        const fx = $('.thumb_item .active');
        document.getElementById("image-zoom-src").href = fx.data('zoomImage');
        fx.parent().parent().addClass('active');
        $(".zoomWrapper div").hide('fast');

        // Video Element
        const activeElm = document.querySelectorAll('.thumb_item .active')[0];
        if(this.thumbType(activeElm) === 'video') {
            document.getElementById("image-zoom-src").classList.add('hidden')
            this.enableVideo(activeElm);
        }else{
            document.getElementById("image-zoom-src").classList.remove('hidden')
            document.querySelector("#image-zoom-src img").style.height = 'auto'
            this.disableVideo();
        }
    }

    /**
     * Get if Thumbnails is a image or a video
     */
    thumbType(thumb){
        return thumb.dataset.thumbType;
    }

    /**
     * Init code execution
     */
    init(){
        this.galleryZoom();
    }
}
document.addEventListener("DOMContentLoaded", function(event) {
    new ProductImagesGallery();
});